
import React from 'react';
import EditModifierGroups from './EditModifierGroups';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import NotFound from '../../not-found/NotFound';
import Layout from '../../../components/Layout';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
  const title = intl.formatMessage(messages.editModifierGroup);

  let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;
  let isEnableAddon = store.getState().siteSettings.data.addons;

  if (!isStoreAuthenticated) {
    return { redirect: '/store/login' };
  };

  if (isEnableAddon === '0') {
    return {
      title,
      component: <Layout><NotFound title='Page Not Found' /></Layout>,
      status: 404,
    };
  }

  const id = Number(params.id);
  return {
    title,
    component: (
      <DashboardLayout>
        <EditModifierGroups title={title} id={id} />
      </DashboardLayout>
    ),
  };
}

export default action;
